// extracted by mini-css-extract-plugin
export default {"BigLoader":"BigLoader_vNTZy_v17-8-1","BigLoader__Text":"BigLoader__Text_dVOli_v17-8-1","__Before-React-Loaded":"__Before-React-Loaded_o4fpq_v17-8-1"};